import Background from '../modules/background.js';
import Loader from '../modules/loader.js';
import DealerSearch from '../modules/dealer-search.js';
import DealerResults from '../modules/dealer-results.js';

export default class SearchView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.bas-search');
        this.header = this.el.querySelector('.bas-header');
        this.filters = this.el.querySelector('.bas-filters');
        this.background = new Background(this, router);
        this.loader = new Loader(this, router);
        this.results = new DealerResults(this, router);
        this.search = new DealerSearch(this, router);
    }

    show() {
        this.el.classList.remove('hide');
        this.search.show();
        this.animate();
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        const self = this;

        this.header.classList.remove('pre-animation');
        this.filters.classList.remove('pre-animation');
        this.header.classList.add('apply-animation');
        this.filters.classList.add('apply-animation');

        setTimeout(() => {
            self.background.el.classList.remove('pre-animation');
        }, 1000);
    }
}
